import React, { useEffect, useRef, useState } from "react";
import MainLayout from "../components/MainLayout";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import { clientsHeader, invoicesHeader } from "../components/HeaderAttribute";
import AddScreenTitle from "../components/AddScreenTitle";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import FileUpload from "../ReusableComponents/FileUpload";
import { mainTable } from "../css/Common";
import {
  BindAPI,
  BindPostAPI,
  ImageAPI,
  IUDAPI,
} from "../services/APIConnection";
import toast from "react-hot-toast";
import Checkbox from "../ReusableComponents/Checkbox";
import MainPopup from "../popup-containers/MainPopup";
import ClientPopup from "../popup-containers/ClientPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Loader from "../ReusableComponents/Loader";

const Client = () => {
  const [partnerBulkUploadData, setPartnerBulkUploadData] = useState("");
  const [partnerBulkUploadDataNew, setPartnerBulkUploadDataNew] = useState([]);
  const [clientsBulkUploadData, setClientsBulkUploadData] = useState("");
  const [clientsBulkUploadDataNew, setClientsBulkUploadDataNew] = useState([]);
  const [bindContactNoAndEmailDatas, setBindContactNoAndEmailDatas] = useState(
    [],
  );
  const [bindInvoicesData, setBindInvoicesData] = useState([]);
  const invoicesData = [
    {
      sno: 1,
      InvoiceType: "Proforma Invoice",
      InvoiceNo: "PIN-2025-000001",
      InvoiceDate: "01-07-2025",
      InvoiceAmount: "₹2,500",
      Status: "Paid",
    },
    {
      sno: 2,
      InvoiceType: "Tax Invoice",
      InvoiceNo: "TIN-2025-000001",
      InvoiceDate: "02-07-2025",
      InvoiceAmount: "₹3,000",
      Status: "Unpaid",
    },
    {
      sno: 3,
      InvoiceType: "Proforma Invoice",
      InvoiceNo: "PIN-2025-000002",
      InvoiceDate: "03-07-2025",
      InvoiceAmount: "₹1,750",
      Status: "Pending",
    },
    {
      sno: 4,
      InvoiceType: "Tax Invoice",
      InvoiceNo: "TIN-2025-000002",
      InvoiceDate: "04-07-2025",
      InvoiceAmount: "₹2,100",
      Status: "Paid",
    },
    {
      sno: 5,
      InvoiceType: "Proforma Invoice",
      InvoiceNo: "PIN-2025-000003",
      InvoiceDate: "05-07-2025",
      InvoiceAmount: "₹4,200",
      Status: "Unpaid",
    },
    {
      sno: 6,
      InvoiceType: "Tax Invoice",
      InvoiceNo: "TIN-2025-000003",
      InvoiceDate: "06-07-2025",
      InvoiceAmount: "₹3,650",
      Status: "Paid",
    },
    {
      sno: 7,
      InvoiceType: "Proforma Invoice",
      InvoiceNo: "PIN-2025-000004",
      InvoiceDate: "07-07-2025",
      InvoiceAmount: "₹2,850",
      Status: "Pending",
    },
    {
      sno: 8,
      InvoiceType: "Tax Invoice",
      InvoiceNo: "TIN-2025-000004",
      InvoiceDate: "08-07-2025",
      InvoiceAmount: "₹1,950",
      Status: "Paid",
    },
    {
      sno: 9,
      InvoiceType: "Proforma Invoice",
      InvoiceNo: "PIN-2025-000005",
      InvoiceDate: "09-07-2025",
      InvoiceAmount: "₹2,200",
      Status: "Unpaid",
    },
    {
      sno: 10,
      InvoiceType: "Tax Invoice",
      InvoiceNo: "TIN-2025-000005",
      InvoiceDate: "10-07-2025",
      InvoiceAmount: "₹3,100",
      Status: "Paid",
    },
  ];

  const [selectedUsersClear, setSelectedUsersClear] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState("");
  const [bindPartnerMasterDatas, setBindPartnerMasterDatas] = useState([]);

  const [bindPartnerMasterDatasChild, setBindPartnerMasterDatasChild] =
    useState([]);
  const [bindImageDatas, setBindImageDatas] = useState([]);
  const [bindUserDatas, setBindUserDatas] = useState([]);
  const [checkboxStatus, setCheckboxStatus] = useState();
  const [getStateDatas, setGetStateDatas] = useState([]);
  const [getCityDatas, setGetCityDatas] = useState([]);
  const [cityBindDD, setCityBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [uploadDetails, setUploadDetails] = useState(false);
  const [userDeactivateDetails, setUserDeactivateDetails] = useState(false);
  const [userActivateDetails, setUserActivateDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [propertyTypeBindDD, setPropertyTypeBindDD] = useState([]);
  const [designationBindDD, setDesignationBindDD] = useState([]);
  const [partnerData, setPartnerData] = useState({});
  const [partnerdata2, setPartnerdata2] = useState({});
  const [popupFlag, setPopupFlag] = useState(0);
  const [popupImage, setPopupImage] = useState([]);
  const [popupUser, setPopupUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const [clientsFields, setClientsFields] = useState({
    clientsId: "CLT",
    clientsName: "",
    address: "",
    country: "1",
    state: "",
    city: "",
    propertyType: "",
    pinCode: "",
    noOfUsersRequired: "",
    subscriptionPeriod: "",
    noOfUsersProvided: "",
    subscriptionFrom: new Date(),
    subscriptionTo: new Date(),
    date: new Date(),
    firstName: null,
    LastName: "",
    showImage: "",
    designation: "",
    contactNumber: "",
    email: "",
    gst: "",
  });

  const [clientsFieldsError, setClientsFieldsError] = useState({
    clientsIdError: "",
    clientsNameError: "",
    propertyTypeError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    cityError: "",
    pinCodeError: "",
    noOfUsersRequiredError: "",
    subscriptionPeriodError: "",
    dateError: "",
    firstNameError: "",
    LastNameError: "",
    designationError: "",
    contactNumberError: "",
    emailError: "",
    showImageError: "",
    gstError: "",
    checkboxStatusError: "",
    showMultiImageError: "",
  });
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  const [fileClear, setFileClear] = useState(false);
  const childRef = useRef();
  // View details start

  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [typeBindDD, settypeBindDD] = useState([
    { value: 1, label: "Villa" },
    { value: 2, label: "Hotel" },
  ]);
  const clear = () => {
    setFileClear(true);
    setSelectedUsersClear(true);

    setSelectedUsers("");
    setClientsFields({
      clientsId: "CLT",
      clientsName: "",
      address: "",
      country: "1",
      state: "",
      city: "",
      propertyType: "",
      pinCode: "",
      noOfUsersRequired: "",
      subscriptionPeriod: "",
      noOfUsersProvided: "",
      subscriptionFrom: "",
      subscriptionTo: "",
      date: new Date(),
      firstName: null,
      LastName: "",
      showImage: "",
      designation: "",
      contactNumber: "",
      email: "",
      gst: "",
    });
    setClientsFieldsError({
      clientsIdError: "",
      clientsNameError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      pinCodeError: "",
      dateError: "",
      firstNameError: "",
      LastNameError: "",
      designationError: "",
      contactNumberError: "",
      emailError: "",
      showImageError: "",
      gstError: "",
      checkboxStatusError: "",
      showMultiImageError: "",
    });
    setShowImage("");
    setSelectedFiles([]);
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false); // Add Screen title & button
    setUpdateScreenTitle(false);
  };
  const API_BASE_URL = window.location.protocol === "https:" ? "https" : "http";
  const [imageDisabled, setImageDisabled] = useState(false);
  const [fileDisabled, setFileDisabled] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showImage, setShowImage] = useState("");
  const [showImageError, setShowImageError] = useState("");
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);

  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    setImageDisabled(false);
    setFileDisabled(true);
    const files = event.target.files;

    const selectedFilesLimited = Array.from(files)
      .filter(
        (file) =>
          isFileFormatAllowed(file) &&
          isFileSizeBelowLimit(file) &&
          !selectedFiles.some(
            (selectedFile) =>
              selectedFile.file.name === file.name &&
              selectedFile.file.size === file.size,
          ), // Prevent duplicate files
      )
      .slice(0, 3);

    if (selectedFiles.length + selectedFilesLimited.length > 3) {
      setImageDisabled(true);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clears the file input value
      }
      toast.error("Cannot select more than 3 files", {
        duration: 3000,
        position: "top-center",
      });
      return;
    }

    setSelectedFiles((prevFiles) => [
      ...prevFiles,
      ...selectedFilesLimited.map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
      })),
    ]);

    const unsupportedFormatFiles = Array.from(files).filter(
      (file) => !isFileFormatAllowed(file),
    );
    if (unsupportedFormatFiles.length > 0) {
      const unsupportedFilesNames = unsupportedFormatFiles
        .map((file) => file.name)
        .join(", ");
      const errorMessage = `Unsupported file format: ${unsupportedFilesNames}`;
      toast.error(errorMessage, {
        duration: 4000,
        position: "top-center",
      });
    }

    const oversizedFiles = Array.from(files).filter(
      (file) => !isFileSizeBelowLimit(file),
    );
    if (oversizedFiles.length > 0) {
      const oversizedFilesNames = oversizedFiles
        .map((file) => file.name)
        .join(", ");
      const errorMessage = `File size exceeds the limit (${MAX_FILE_SIZE_MB}MB)`;
      toast.error(errorMessage, {
        duration: 4000,
        position: "top-center",
      });
    }
  };

  const handleUpload = async () => {
    setImageDisabled(true);
    if (selectedFiles.length === 0) {
      // Handle case where no files are selected
      toast.error("Please select files to upload", {
        duration: 2000,
        position: "top-center",
      });
      return;
    }

    const formData = new FormData();

    // Append each selected file to the formData
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("PropertyPhoto", selectedFiles[i].file);
    }

    try {
      const response = await ImageAPI(
        formData,
        "ClientsAPI/PropertyPhotoUpload",
      );

      // Check if the API response contains image URLs
      if (Array.isArray(response.data) && response.data.length > 0) {
        // Update state with image URLs

        const allImageUrls = [
          ...selectedFiles.map((fileObj) => fileObj.previewUrl),
          ...response.data.map((fileUrl) => fileUrl),
        ];

        // Filter out URLs that start with 'blob:http://'
        const filteredImageUrls = allImageUrls.filter(
          (url) => !url.startsWith(`blob:${API_BASE_URL}://`),
        );

        const imageUrlString = filteredImageUrls.join(",");

        setShowImage(imageUrlString);
        toast.success("Images uploaded successfully 📷", {
          duration: 3000,
          position: "top-center",
        });
        setFileDisabled(false);
        setClientsFieldsError({
          showMultiImageError: "",
        });
      } else {
        toast.error("Failed to upload images 👎", {
          duration: 2000,
          position: "top-center",
        });
      }
    } catch (error) {
      toast.error("Failed to upload images 👎", {
        duration: 2000,
        position: "top-center",
      });
    }
  };
  const handleImageCancel = (index) => {
    setImageDisabled(true);
    setFileDisabled(false);
    const updatedTableData = [...selectedFiles];
    updatedTableData.splice(index, 1);
    setSelectedFiles(updatedTableData);
    const formData = new FormData();
    const imageUrlArray = [];

    for (let i = 0; i < updatedTableData.length; i++) {
      imageUrlArray.push(updatedTableData[i].previewUrl);
    }
    const imageUrlString = imageUrlArray.join(",");

    setShowImage(imageUrlString);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clears the file input value
    }
  };
  useEffect(() => {
    const fetchAllMasterData = async () => {
      try {
        // Fetch master data in one call
        const response = await BindAPI("MasterDataAPI/BindMasterDatas");

        if (response?.data) {
          const { Table, Table1, Table2 } = response.data;

          // Country
          const countryDD =
            Table?.map((m) => ({
              value: m.MstCountryId,
              label: m.CountryName,
            })) || [];
          setCountryBindDD(countryDD);

          // State
          setGetStateDatas(Table1 || []);

          // Location
          setGetCityDatas(Table2 || []);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
      }

      // Designation
      try {
        const resDesignation = await BindAPI("MasterDataAPI/BindDesignation");
        if (resDesignation?.data?.Table) {
          const designationDD = resDesignation.data.Table.map((item) => ({
            value: item.MstDesignationId.toString(),
            label: item.Designation,
          }));
          setDesignationBindDD(designationDD);
        }
      } catch (error) {
        console.error("Error fetching designation data:", error);
      }

      // Property Type
      try {
        const resType = await BindAPI("MasterDataAPI/BindPropertyType");
        if (resType?.data?.Table) {
          const propertyTypeOptions = resType.data.Table.map((item) => ({
            value: item.MstPropertyTypeId.toString(),
            label: item.PropertyType,
          }));
          setPropertyTypeBindDD(propertyTypeOptions);
        }
      } catch (error) {
        console.error("Error fetching property propertyType data:", error);
      }
    };

    fetchAllMasterData();
  }, []);

  useEffect(() => {
    if (!clientsFields.country || getStateDatas.length === 0) return;

    const filteredStates = getStateDatas
      .filter((item) => item.MstCountryId == clientsFields.country)
      .map((item) => ({
        value: item.MstStateId,
        label: item.State,
      }));

    setStateBindDD(filteredStates);
  }, [clientsFields.country, getStateDatas]);

  useEffect(() => {
    if (!clientsFields.state || getCityDatas.length === 0) return;

    const filteredCitys = getCityDatas
      .filter((item) => item.MstStateId == clientsFields.state)
      .map((item) => ({
        value: item.MstCityId,
        label: item.City,
      }));

    setCityBindDD(filteredCitys);
  }, [clientsFields.state, getCityDatas]);

  const BindPartnerGridData = async () => {
    try {
      setIsLoading(true);
      const { data } = await BindAPI("ClientsAPI/BindClients");

      setBindPartnerMasterDatas(data?.Table ?? []);

      setBindPartnerMasterDatasChild(data?.Table3 ?? []);
      if (data?.Table.length > 0) {
        setVisibleTable(true);
        setVisibleAdd(false);
      } else {
        showAdd();
      }
      setBindContactNoAndEmailDatas(data?.Table1 ?? []);
      setBindUserDatas(data?.Table2 ?? []);
      setBindImageDatas(data?.Table4 ?? []);
    } catch (error) {
      console.error("Error fetching partner data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    BindPartnerGridData();
  }, []);
  const handleClientData = (values) => {
    console.log("Received from child:", values);
    setClientsFields({
      ...clientsFields,
      noOfUsersProvided: values.numberofUsersProvided,
      subscriptionFrom: values.fromDate,
      subscriptionTo: values.toDate,
    });
    // you can save this in state, form, etc.
  };

  useEffect(() => {
    const getMenuTableDatas = async () => {
      let rightsResponse;
      try {
        rightsResponse = await BindAPI(
          "RoleVsCapabilityAPI/BindRoleVsCapability",
        );
        const response = await BindAPI("RoleVsCapabilityAPI/BindScreenMenu");
        const organizedData = {};

        const processMenuData = (menuHeadingId) => {
          const filteredData = response.data.Table.filter(
            (item) => item.MstMenuHeadingId === menuHeadingId,
          );

          const menuList = {};

          filteredData.forEach((item) => {
            if (!menuList[item.MenuName]) {
              menuList[item.MenuName] = {
                MenuName: item.MenuName,
                MstMenuId: item.MainMenuId ? null : item.MstMenuId,
                MainMenuId: item.MainMenuId,
                MstMenuHeadingId: item.MstMenuHeadingId,
                checked:
                  item.MainMenuId && item.SubMenu && item.SubMenu.length > 0
                    ? null
                    : [],
                SubMenu: [],
                View: item.View,
                Add: item.Add,
                Edit: item.Edit,
                Delete: item.Delete,
                Inactive: item.Inactive,
                Service: item.Service,
              };
            }

            const submenuFiltered = response.data.Table.filter(
              (subItem) =>
                subItem.MenuName === item.MenuName &&
                subItem.MainMenuId &&
                subItem.MstMenuHeadingId === menuHeadingId &&
                subItem.MstMenuId != 30,
            ).map((subItem) => ({
              SubMenu: subItem.SubMenu,
              MstMenuId: subItem.MstMenuId,
              MainMenuId: subItem.MainMenuId,
              MstMenuHeadingId: subItem.MstMenuHeadingId,
              checked: [],
              View: item.View,
              Add: item.Add,
              Edit: item.Edit,
              Delete: item.Delete,
              Inactive: item.Inactive,
              Service: item.Service,
            }));

            const arr = rightsResponse.data.Table.filter(
              (e) =>
                e.MstMenuId == menuList[item.MenuName].MstMenuId &&
                e.MstRoleId == 2,
            );
            const checkedData =
              arr.length > 0
                ? {
                    add: arr[0].AddPermission === 1,
                    view: arr[0].ViewPermission === 1,
                    inActive: arr[0].BlockPermission === 1,
                    delete: arr[0].DeletePermission === 1,
                    edit: arr[0].ModifyPermission === 1,
                    service: arr[0].ProvideServicePermission === 1,
                    title:
                      arr[0].AddPermission === 1 &&
                      arr[0].ViewPermission === 1 &&
                      arr[0].BlockPermission === 1 &&
                      arr[0].DeletePermission === 1 &&
                      arr[0].ModifyPermission === 1 &&
                      arr[0].ProvideServicePermission === 1,
                  }
                : {
                    title: false,
                    add: false,
                    view: false,
                    inActive: false,
                    delete: false,
                    edit: false,
                    service: false,
                  };
            if (menuList[item.MenuName].checked !== null) {
              menuList[item.MenuName].checked.push(checkedData);
            }

            submenuFiltered.forEach((subItem) => {
              const subMenuItemExists = menuList[item.MenuName].SubMenu.some(
                (existingSubMenu) => existingSubMenu.SubMenu == subItem.SubMenu,
              );
              if (!subMenuItemExists) {
                const arr = rightsResponse.data.Table.filter(
                  (e) => e.MstMenuId == subItem.MstMenuId && e.MstRoleId == 2,
                );
                subItem.checked =
                  arr.length > 0
                    ? {
                        add: arr[0].AddPermission === 1,
                        view: arr[0].ViewPermission === 1,
                        inActive: arr[0].BlockPermission === 1,
                        delete: arr[0].DeletePermission === 1,
                        edit: arr[0].ModifyPermission === 1,
                        service: arr[0].ProvideServicePermission === 1,
                        title:
                          arr[0].AddPermission === 1 &&
                          arr[0].ViewPermission === 1 &&
                          arr[0].BlockPermission === 1 &&
                          arr[0].DeletePermission === 1 &&
                          arr[0].ModifyPermission === 1 &&
                          arr[0].ProvideServicePermission === 1,
                      }
                    : {
                        title: false,
                        add: false,
                        view: false,
                        inActive: false,
                        delete: false,
                        edit: false,
                        service: false,
                      };

                if (!subMenuItemExists) {
                  menuList[item.MenuName].SubMenu.push(subItem);
                }
              }
            });
          });

          return Object.values(menuList);
        };

        organizedData.Dashboard = processMenuData(1); // Dashboard
        organizedData.Administrator = processMenuData(2); // Administrator
        organizedData.Transaction = processMenuData(3); // Transaction
        organizedData.Report = processMenuData(4); // Reports

        setClientsBulkUploadData(organizedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getMenuTableDatas();
  }, [clientsFields.email]);

  // const createdBy = sessionStorage.getItem("createdBy");

  const convertOrganizedMenuData = (menuData, handleRoleChange) => {
    const convertedMenuData = [];

    Object.keys(menuData).forEach((key) => {
      menuData[key].forEach((item) => {
        // Process main menu if MstMenuId is not null
        if (item.MstMenuId !== null) {
          convertedMenuData.push({
            MstRoleId: handleRoleChange,
            MstMenuHeadingId: item.MstMenuHeadingId,
            MstMenuId: item.MstMenuId,
            ViewPermission: item.checked?.[0]?.view ? 1 : 0,
            AddPermission: item.checked?.[0]?.add ? 1 : 0,
            ModifyPermission: item.checked?.[0]?.edit ? 1 : 0,
            DeletePermission: item.checked?.[0]?.delete ? 1 : 0,
            InActivePermission: item.checked?.[0]?.inActive ? 1 : 0,
            ProvideServicePermission: item.checked?.[0]?.service ? 1 : 0,
            CreatedBy: 0,
          });
        }

        // Process submenus if available
        if (item.SubMenu && item.SubMenu.length > 0) {
          item.SubMenu.forEach((submenu) => {
            if (submenu.MstMenuId !== null) {
              convertedMenuData.push({
                MstRoleId: handleRoleChange,
                MstMenuHeadingId:
                  submenu.MstMenuHeadingId || item.MstMenuHeadingId,
                MstMenuId: submenu.MstMenuId,
                ViewPermission: submenu.checked?.view ? 1 : 0,
                AddPermission: submenu.checked?.add ? 1 : 0,
                ModifyPermission: submenu.checked?.edit ? 1 : 0,
                DeletePermission: submenu.checked?.delete ? 1 : 0,
                InActivePermission: submenu.checked?.inActive ? 1 : 0,
                ProvideServicePermission: submenu.checked?.service ? 1 : 0,
                CreatedBy: 0,
              });
            }
          });
        }
      });
    });

    return convertedMenuData;
  };
  useEffect(() => {
    if (clientsBulkUploadData) {
      // make sure data is not null or undefined
      const convertedMenuData = convertOrganizedMenuData(
        clientsBulkUploadData,
        2,
      );
      setClientsBulkUploadDataNew(convertedMenuData);
    }
  }, [clientsBulkUploadData]);
  const handleClientsFieldsChange = (value, name) => {
    setClientsFields({
      ...clientsFields,
      [name]: value,
    });
  };
  const cancel = () => {
    BindPartnerGridData();
    if (
      childRef.current &&
      typeof childRef.current.childCancelFunction === "function"
    ) {
      childRef.current.childCancelFunction(); // ✅ Safe call
    } else {
      console.error("childCancelFunction is not defined");
    }
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    //  navigate("/");
    //   closePopup();
    clear();
  };
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
  };
  const handleViewFile = async (rowIndex, flag, file) => {
    // if (file == 1) {
    //   const rowData = bindPaymentInfoData[rowIndex].ProformaInvoice;
    //   setSelectedFileUrl(rowData);
    // } else if (file == 2) {
    //   const rowData = bindPaymentInfoData[rowIndex].TaxInvoice;
    //   setSelectedFileUrl(rowData);
    // }
    const data = {
      mstClientId: bindPartnerMasterDatas[rowIndex].MstClientId,
    };

    const response = await BindPostAPI(data, "ClientsAPI/BindClientInvoices");

    setBindInvoicesData(response?.data?.Table ?? []);
    debugger;
    setShowFileModal(true);
  };
  const isImageFile = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
    const ext = url?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };
  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();

    return extension === "pdf"
      ? url
      : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          url,
        )}`;
  };
  const handleClient = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setUploadDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setUserDeactivateDetails(false);
      setUserActivateDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setUploadDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setUserDeactivateDetails(false);
      setUserActivateDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setUploadDetails(false);
      setBlockDetails(true);
      setUserDeactivateDetails(false);
      setUserActivateDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUserDeactivateDetails(false);
      setUserActivateDetails(false);
      setUploadDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    } else if (flag === 6) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUploadDetails(true);
      setUserDeactivateDetails(false);
      setUserActivateDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 7) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUploadDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
      setUserDeactivateDetails(true);
      setUserActivateDetails(false);
    } else if (flag === 8) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUploadDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
      setUserDeactivateDetails(false);
      setUserActivateDetails(true);
    }
    const imageData = bindImageDatas.filter(
      (ST) => ST.MstClientId == bindPartnerMasterDatas[rowIndex].MstClientId,
    );
    setPopupImage(imageData);
    const userData = bindUserDatas.filter(
      (ST) => ST.MstClientId == bindPartnerMasterDatas[rowIndex].MstClientId,
    );
    setPopupUser(userData);
    console.log("imageData", imageData);
    setPartnerData(bindPartnerMasterDatas[rowIndex]);
    console.log("datas", bindPartnerMasterDatas[rowIndex]);
    const CountryrowData = bindPartnerMasterDatas[rowIndex];
    const CountryInfo = countryBindDD.find(
      (ST) => ST.value == CountryrowData.MstCountryId,
    );
    const resultCountry = {
      value: CountryrowData.MstCountryId,
      label: CountryInfo ? CountryInfo.label : "",
    };
    const StaterowData = bindPartnerMasterDatas[rowIndex];
    const StateInfo = stateBindDD.find(
      (ST) => ST.value == StaterowData.MstStateId,
    );
    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "",
    };
    const CityrowData = bindPartnerMasterDatas[rowIndex];
    const CityInfo = getCityDatas.find(
      (ST) => ST.MstCityId == CityrowData.MstCityId,
    );
    const resultCity = {
      value: CityrowData.MstCityId,
      label: CityInfo ? CityInfo.City : "",
    };
    const PropertyTyperowData = bindPartnerMasterDatas[rowIndex];
    const PropertyTypeInfo = propertyTypeBindDD.find(
      (ST) => ST.value == PropertyTyperowData.PropertyType,
    );
    const resultPropertyType = {
      value: PropertyTyperowData.PropertyType,
      label: PropertyTypeInfo ? PropertyTypeInfo.label : "",
    };
    const DesignationrowData = bindPartnerMasterDatas[rowIndex];
    const DesignationInfo = designationBindDD.find(
      (ST) => ST.value == DesignationrowData.Designation,
    );
    const resultDesignation = {
      value: DesignationrowData.Designation,
      label: DesignationInfo ? DesignationInfo.label : "",
    };
    const Partnerdata2 = [
      resultCountry,
      resultState,
      resultCity,
      resultPropertyType,
      resultDesignation,
    ];
    setPopupFlag(flag);
    setPartnerdata2(Partnerdata2);
  };
  const handleCheckboxChange = (selected) => {
    setCheckboxStatus(selected);
  };

  const handleClick = () => {
    childRef.current.childFunction(); // Calling child function
  };
  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    debugger;
    setIsLoading(true);
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...clientsFieldsError,
        clientsNameError:
          clientsFields.clientsName && clientsFields.clientsName.length > 0
            ? /^[0-9A-Za-z.'-][0-9A-Za-z.' -]{2,100}$/.test(
                clientsFields.clientsName,
              )
              ? ""
              : clientsFields.clientsName.length < 3
                ? "Minimum 3 characters required"
                : clientsFields.clientsName.length > 100
                  ? "Maximum 100 characters allowed"
                  : "Only alphabets, dot, apostrophe, hyphen, and space allowed"
            : "Enter Name",
        addressError:
          clientsFields.address && clientsFields.address.length > 0
            ? /^[A-Za-z0-9,.'\-\/][A-Za-z0-9,.' \-\/]+$/.test(
                clientsFields.address,
              )
              ? ""
              : "Only alphabets, numbers, commas, dots, apostrophes, hyphens, slashes, and spaces allowed"
            : "Enter Address",
        countryError: clientsFields.country ? "" : "Select Country",
        stateError: clientsFields.state ? "" : "Select State",
        cityError: clientsFields.city ? "" : "Select City",

        propertyTypeError: clientsFields.propertyType
          ? ""
          : "Select Property Type",
        checkboxStatusError: checkboxStatus
          ? ""
          : "Accept The Terms and Conditions.",
        showMultiImageError: showImage ? "" : "Select Property photo",

        pinCodeError:
          clientsFields.pinCode?.trim().length === 6 &&
          /^[0-9]{6}$/.test(clientsFields.pinCode.trim()) &&
          clientsFields.pinCode.trim() !== "000000"
            ? ""
            : "Enter a valid 6-digit pin code",

        firstNameError:
          clientsFields.firstName && clientsFields.firstName.length > 0
            ? /^[A-Za-z.'\-][A-Za-z.'\- ]{2,50}$/.test(clientsFields.firstName)
              ? ""
              : clientsFields.firstName.length < 2
                ? "Minimum 2 characters required"
                : clientsFields.firstName.length > 50
                  ? "Maximum 50 characters allowed"
                  : "Only alphabets, dot, apostrophe, hyphen, and space allowed"
            : "Enter First Name",
        LastNameError:
          clientsFields.LastName && clientsFields.LastName.trim().length > 0
            ? /^[A-Za-z.'\- ]{1,50}$/.test(clientsFields.LastName.trim())
              ? ""
              : clientsFields.LastName.trim().length > 50
                ? "Maximum 50 characters allowed"
                : "Only alphabets, dot, apostrophe, hyphen, and space allowed"
            : "Enter Last Name",

        contactNumberError:
          clientsFields.contactNumber && clientsFields.contactNumber.length > 0
            ? /^\+?[0-9]{7,15}$/.test(clientsFields.contactNumber)
              ? ""
              : "Only digits allowed, with optional + at start (7 to 15 digits)"
            : "Enter Contact Number",
        emailError:
          clientsFields.email.length > 0
            ? /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
                clientsFields.email,
              )
              ? !updateScreenTitle &&
                bindContactNoAndEmailDatas.find(
                  (x) =>
                    (x.Email?.toLowerCase() || "") ===
                    (clientsFields.email?.toLowerCase() || ""),
                )
                ? "Email Address already available"
                : ""
              : "Enter Valid Email Id"
            : "Enter Email",

        contactPersonDesignationError: clientsFields.designation
          ? ""
          : "Select Designation",
        gstError:
          clientsFields.gst && clientsFields.gst.trim().length > 0
            ? /^[A-Za-z0-9,.'\-\/ ]+$/.test(clientsFields.gst)
              ? ""
              : "Only alphabets, numbers, commas, dots, apostrophes, hyphens, slashes, and spaces allowed"
            : "Enter GST",
      };
      setClientsFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === "",
      );
      if (!isFormValid) {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        return; // Prevent popup close or submission
      }
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const clientsPayload = {
          mstClientId: 0,
          propertyType: parseInt(clientsFields.propertyType) || 0,
          name: clientsFields.clientsName,
          address: clientsFields.address,
          mstCountryId: parseInt(clientsFields.country) || 0,
          mstStateId: parseInt(clientsFields.state) || 0,
          mstCityId: parseInt(clientsFields.city) || 0,
          pinCode: clientsFields.pinCode,
          noofUsersRequired: clientsFields.noOfUsersRequired ?? "",
          subscriptionPeriodMonths: clientsFields.subscriptionPeriod ?? "",
          firstName: clientsFields.firstName,
          lastName: clientsFields.LastName,
          designation: parseInt(clientsFields.designation) || 0,
          contactNumber: clientsFields.contactNumber,
          email: clientsFields.email,
          logo: clientsFields.showImage,
          propertyPhoto: showImage,
          termsandConditions: "test",
          encryptedPwd: "1234",
          bulkUpload: JSON.stringify(clientsBulkUploadDataNew),
          gstno: clientsFields.gst,
          selectedUsers: selectedUsers,
          createdBy: parseInt(createdBy) || 0,
          flag: flag,
        };

        const response = await IUDAPI(
          [clientsPayload],
          "ClientsAPI/IUDClients",
        );

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success(" Registration Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Assessee Registration 👎", {
              duration: 2000,
              position: "top-center",
            });
            // Don't close popup on error
          }
        }
        if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success(" Client Modified Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Client Modified 👎", {
              duration: 2000,
              position: "top-center",
            });
            // Don't close popup on error
          }
        }
      }
    } else if (flag == 7 || flag == 8) {
      setIsLoading(true);
      debugger;
      const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return d.toISOString().split("T")[0]; // returns "YYYY-MM-DD"
      };

      if (selectedUsers != "") {
        const data = {
          mstClientId:
            parseInt(bindPartnerMasterDatas[items]?.MstClientId) || 0,
          noofUsersRequired: clientsFields?.noOfUsersRequired || "",
          subscriptionPeriodMonths: clientsFields?.subscriptionPeriod || "",
          subscriptionPeriodFrom: formatDate(clientsFields?.subscriptionFrom),
          subscriptionPeriodTo: formatDate(clientsFields?.subscriptionTo),
          noofUsersProvided: clientsFields?.noOfUsersProvided || "",
          selectedUsers: selectedUsers,
          createdBy: parseInt(createdBy) || 0,
          flag: flag,
        };

        const response = await IUDAPI([data], "ClientsAPI/IUDClients");

        if (flag == 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success(
              `Client Data Deleted Successfully 🗑️`,
              5000,
              cancel(),
            );
          } else {
            toast.error(`Failed To Delete Client Data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag === 5) {
          const result = response?.data?.Table?.[0]?.Result;
          const client = bindPartnerMasterDatas?.[items];

          if (result === "UB") {
            if (!client?.DBName) {
              const paddedClientId = client?.MstClientId?.toString().padStart(
                6,
                "0",
              );
              const newSchemaName = `staycool_test_${paddedClientId}`;

              const newSchemaPayload = {
                oldSchema: "staycooltestclient",
                newSchema: newSchemaName,
              };

              await IUDAPI(newSchemaPayload, "SchemaCloneAPI/SchemaCloneAPI");

              const updateSchemaPayload = {
                mstClientId: parseInt(client?.MstClientId) || 0,
                newSchema: newSchemaName,
              };

              await IUDAPI(updateSchemaPayload, "ClientsAPI/IUDUpdateDBName");
            }

            toast.success("Client Data Activated Successfully 🚀", {
              duration: 5000,
              position: "top-center",
            });

            cancel();
          } else {
            toast.error("Failed To Activate Client Data 👎", {
              duration: 2000,
              position: "top-center",
            });

            setTimeout(cancel, 2000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success(
              `Client Data Inactive Successfully ✅`,
              5000,
              cancel(),
            );
            cancel();
          } else {
            toast.error(`Failed To Inactive Client Data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 7) {
          if (response.data.Table[0].Result === "DL") {
            toast.success(
              `Client Data Deactivate Successfully ✅`,
              5000,
              cancel(),
            );
            cancel();
          } else {
            toast.error(`Failed To Deactivate Client Data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 8) {
          if (response.data.Table[0].Result === "AL") {
            toast.success(
              `Client Data Activate Successfully ✅`,
              5000,
              cancel(),
            );
            cancel();
          } else {
            toast.error(`Failed To Activate Client Data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        toast.error("Please select the Check box 👎", {
          duration: 2000,
          position: "top-center",
        });
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
    } else {
      setIsLoading(true);

      const data = {
        mstClientId: parseInt(bindPartnerMasterDatas[items]?.MstClientId) || 0,
        propertyType: parseInt(clientsFields.propertyType) || 0,
        name: clientsFields.clientsName,
        address: clientsFields.address,
        mstCountryId: parseInt(clientsFields.country) || 0,
        mstStateId: parseInt(clientsFields.state) || 0,
        mstCityId: parseInt(clientsFields.city) || 0,
        pinCode: clientsFields.pinCode,
        noofUsersRequired: clientsFields.noOfUsersRequired ?? "",
        subscriptionPeriodMonths: clientsFields.subscriptionPeriod ?? "",
        firstName: clientsFields.firstName,
        lastName: clientsFields.LastName,
        designation: parseInt(clientsFields.designation) || 0,
        contactNumber: clientsFields.contactNumber,
        email: clientsFields.email,
        logo: clientsFields.showImage,
        propertyPhoto: showImage,
        termsandConditions: "test",
        encryptedPwd: "1234",
        bulkUpload: JSON.stringify(clientsBulkUploadDataNew),
        gstno: clientsFields.gst,
        selectedUsers: selectedUsers,
        createdBy: parseInt(createdBy) || 0,
        flag: flag,
      };

      try {
        const response = await IUDAPI([data], "ClientsAPI/IUDClients");

        // ********** FIXED RESPONSE HANDLING (DataSet Format) **********
        const ds = response.data;

        if (!ds || !ds.Table || ds.Table.length === 0) {
          toast.error("Invalid response from server ❌", { duration: 2000 });
          setIsLoading(false);
          return;
        }

        const result = ds.Table[0].Result;

        // *******************************************
        // FLAG 3 → Delete Client
        // *******************************************
        if (flag === 3) {
          if (result === "D") {
            toast.success("Client Data Deleted Successfully 🗑️", {
              duration: 3000,
            });
          } else {
            toast.error("Failed To Delete Client Data 👎", { duration: 2000 });
          }
          cancel();
        }

        // *******************************************
        // FLAG 5 → Activate Client + Schema Clone
        // *******************************************
        else if (flag === 5) {
          const client = bindPartnerMasterDatas?.[items];

          if (result === "UB") {
            if (!client?.DBName) {
              const paddedClientId = client?.MstClientId?.toString().padStart(
                6,
                "0",
              );
              const newSchemaName = `staycool_${paddedClientId}`;

              const newSchemaPayload = {
                oldSchema: "staycoolclient",
                newSchema: newSchemaName,
              };

              await IUDAPI(newSchemaPayload, "SchemaCloneAPI/SchemaCloneAPI");

              const updateSchemaPayload = {
                mstClientId: parseInt(client?.MstClientId) || 0,
                newSchema: newSchemaName,
              };

              await IUDAPI(updateSchemaPayload, "ClientsAPI/IUDUpdateDBName");
            }

            toast.success("Client Data Activated Successfully 🚀", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("Failed To Activate Client Data 👎", {
              duration: 2000,
              position: "top-center",
            });
          }
          cancel();
        }

        // *******************************************
        // FLAG 4 → Inactive Client
        // *******************************************
        else if (flag === 4) {
          if (result === "B") {
            toast.success("Client Data Inactive Successfully ✅", {
              duration: 3000,
            });
          } else {
            toast.error("Failed To Inactive Client Data 👎", {
              duration: 2000,
            });
          }
          cancel();
        }

        // *******************************************
        // FLAG 7 → Deactivate Login
        // *******************************************
        else if (flag === 7) {
          if (result === "DL") {
            toast.success("Client Login Deactivated Successfully 🚫", {
              duration: 3000,
            });
          } else {
            toast.error("Failed To Deactivate Client Login 👎", {
              duration: 2000,
            });
          }
          cancel();
        }

        // *******************************************
        // FLAG 8 → Activate Login
        // *******************************************
        else if (flag === 8) {
          if (result === "AL") {
            toast.success("Client Login Activated Successfully ✅", {
              duration: 3000,
            });
          } else {
            toast.error("Failed To Activate Client Login 👎", {
              duration: 2000,
            });
          }
          cancel();
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something Went Wrong ❌", { duration: 2000 });
      }

      setIsLoading(false);
    }
  };
  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    const selectedRow = bindPartnerMasterDatas[rowIndex];
    setClientsFields({
      clientsId: selectedRow.MstClientId,
      clientsName: selectedRow.PropertyName,
      address: selectedRow.Address,
      country: selectedRow.MstCountryId,
      state: selectedRow.MstStateId,
      city: selectedRow.MstCityId,
      propertyType: selectedRow.PropertyType,
      pinCode: selectedRow.PinCode,
      noOfUsersRequired: selectedRow.NoofUsersRequired,
      subscriptionPeriod: selectedRow.SubscriptionPeriodMonths,
      noOfUsersProvided: selectedRow.NoofUsersRequired,
      subscriptionFrom: selectedRow.SubscriptionPeriodFrom
      ? selectedRow.SubscriptionPeriodFrom.split("T")[0]
      : "",
    
    subscriptionTo: selectedRow.SubscriptionPeriodTo
      ? selectedRow.SubscriptionPeriodTo.split("T")[0]
      : "",
      firstName: selectedRow.FirstName,
      LastName: selectedRow.LastName,
      showImage: selectedRow.LastName,
      designation: selectedRow.Designation,
      contactNumber: selectedRow.ContactNumber,
      email: selectedRow.Email,
      gst: selectedRow.GSTNO,
    });
    setCheckboxStatus([1]);
    const filteredData = bindPartnerMasterDatasChild.find(
      (item) => item.MstClientId === selectedRow.MstClientId,
    );

    if (filteredData && filteredData.PropertyPhoto) {
      const fileData = filteredData.PropertyPhoto.split(",");
      const fileupload = fileData.map((item, index) => ({
        file: { name: `Image ${index + 1}` },
        previewUrl: item.trim(),
      }));

      const imageUrlArray = fileupload.map((f) => f.previewUrl);
      const imageUrlString = imageUrlArray.join(",");

      setSelectedFiles(fileupload);
      setShowImage(imageUrlString);
    }
  };

  const handleShowImage = (showImage) => {
    // Set showImage to an empty string if showImage is falsy
    setClientsFields({
      ...clientsFields,
      showImage: showImage || "", // This will set to showImage if it's truthy, else ""
    });

    // Reset any error related to showImage
    setClientsFieldsError({ ...clientsFieldsError, showImageError: "" });
  };

  const handleSelectedUser = (values) => {
    const selectedUsers = values.map((index) => popupUser[index]);

    const userIds = selectedUsers.map((user) => user.MstUserId);

    const userIdsString = userIds.join(",");

    console.log(userIds);
    setSelectedUsers(userIdsString);
  };

  const handleSelectedUserClear = (values) => {
    setSelectedUsersClear(false);
  };

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Clients"
          header={clientsHeader}
          records={bindPartnerMasterDatas}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleClient}
          onViewFile={handleViewFile}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <>
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Clients"
              />
            </div>
          </div>

          <div class=" flex flex-col w-full">
            <div class={mainTable.clientMasterMainAdd}>
              <div class={mainTable.addShadowScreen}>
                <div class={mainTable.mainContentScreen}>
                  <form class={mainTable.formForClientMaster}>
                    <div class={mainTable.grid3}>
                      <AutoDropDown
                        title="Property Type"
                        options={propertyTypeBindDD}
                        placeholder="Select"
                        name="propertyType"
                        selectedOption={propertyTypeBindDD.find(
                          (x) => x.value == clientsFields.propertyType,
                        )}
                        Class="custom-class"
                        // // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value, e) => {
                          handleClientsFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setClientsFieldsError(() => ({
                            ...clientsFieldsError,
                            propertyTypeError: clientsFields.propertyType
                              ? ""
                              : "Select Property Type",
                          }));
                        }}
                        errorMessage={clientsFieldsError.propertyTypeError}
                      />
                      <InputText
                        inputType={"text"}
                        title={" Name"}
                        name={"clientsName"}
                        classStar={"text-red-500"}
                        maxLength={100}
                        content={clientsFields.clientsName}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            clientsName: e.target.value,
                          })
                        }
                        controlFuncBlur={() => {
                          setClientsFieldsError((clientsFieldsError) => ({
                            ...clientsFieldsError,
                            clientsNameError:
                              clientsFields.clientsName &&
                              clientsFields.clientsName.length > 0
                                ? /^[0-9A-Za-z.'-][0-9A-Za-z.' -]{2,100}$/.test(
                                    clientsFields.clientsName,
                                  )
                                  ? ""
                                  : clientsFields.clientsName.length < 3
                                    ? "Minimum 3 characters required"
                                    : clientsFields.clientsName.length > 100
                                      ? "Maximum 100 characters allowed"
                                      : "Only alphabets, dot, apostrophe, hyphen, and space allowed"
                                : "Enter Name",
                          }));
                        }}
                        errorMessage={clientsFieldsError.clientsNameError}
                      />
                      <InputText
                        inputType={"text"}
                        title={"Address"}
                        maxLength={500}
                        name={"address"}
                        classStar={"text-red-500"}
                        content={clientsFields.address}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            address: e.target.value,
                          })
                        }
                        controlFuncBlur={() => {
                          setClientsFieldsError((clientsFieldsError) => ({
                            ...clientsFieldsError,
                            addressError:
                              clientsFields.address &&
                              clientsFields.address.length > 0
                                ? /^[A-Za-z0-9,.'\-\/][A-Za-z0-9,.' \-\/]+$/.test(
                                    clientsFields.address,
                                  )
                                  ? ""
                                  : "Only alphabets, numbers, commas, dots, apostrophes, hyphens, slashes, and spaces allowed"
                                : "Enter Address",
                          }));
                        }}
                        errorMessage={clientsFieldsError.addressError}
                      />
                      <AutoDropDown
                        title="Country"
                        options={countryBindDD}
                        placeholder="Select"
                        name="country"
                        selectedOption={countryBindDD.find(
                          (x) => x.value == clientsFields.country,
                        )}
                        Class="custom-class"
                        // // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value, e) => {
                          handleClientsFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setClientsFieldsError(() => ({
                            ...clientsFieldsError,
                            countryError: clientsFields.country
                              ? ""
                              : "Select Country",
                          }));
                        }}
                        errorMessage={clientsFieldsError.countryError}
                      />
                      <AutoDropDown
                        title="State"
                        options={stateBindDD}
                        placeholder="Select"
                        name="state"
                        selectedOption={
                          clientsFields.state
                            ? stateBindDD.find(
                                (x) => x.value == clientsFields.state,
                              )
                            : ""
                        }
                        Class="p-0"
                        // // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value, e) => {
                          handleClientsFieldsChange(value.value, e.name);
                          setClientsFields({
                            ...clientsFields,
                            state: value.value,
                            city: "",
                          });
                          setClientsFieldsError({
                            ...clientsFieldsError,
                            stateError: value ? "" : "Select State",
                          });
                        }}
                        controlFuncBlur={() => {
                          setClientsFieldsError(() => ({
                            ...clientsFieldsError,
                            stateError: clientsFields.state
                              ? ""
                              : "Select State",
                          }));
                        }}
                        errorMessage={clientsFieldsError.stateError}
                      />
                      <AutoDropDown
                        title="City"
                        options={cityBindDD}
                        placeholder="Select"
                        name="city"
                        selectedOption={
                          clientsFields.city
                            ? cityBindDD.find(
                                (x) => x.value == clientsFields.city,
                              )
                            : ""
                        }
                        Class="custom-class"
                        // // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value, e) => {
                          handleClientsFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setClientsFieldsError(() => ({
                            ...clientsFieldsError,
                            cityError: clientsFields.city ? "" : "Select City",
                          }));
                        }}
                        errorMessage={clientsFieldsError.cityError}
                      />
                      <InputText
                        inputType={"text"}
                        title={"Pin Code"}
                        name={"pinCode"}
                        classStar={"text-red-500"}
                        maxLength={10}
                        content={clientsFields.pinCode}
                        controlFunc={(e) => {
                          const inputVal = e.target.value;
                          // Allow only digits
                          const onlyDigitsRegex = /^[0-9]*$/;
                          if (onlyDigitsRegex.test(inputVal)) {
                            setClientsFields({
                              ...clientsFields,
                              pinCode: inputVal,
                            });
                          }
                        }}
                        // controlFuncBlur={() => {
                        //   const trimmedPin = clientsFields.pinCode?.trim() || "";
                        //   setClientsFieldsError((clientsFieldsError) => ({
                        //     ...clientsFieldsError,
                        //     pinCodeError:
                        //       trimmedPin.length === 6
                        //         ? ""
                        //         : "Enter a valid 6-digit pin code",
                        //   }));
                        // }}

                        controlFuncBlur={() => {
                          const trimmedPin =
                            clientsFields.pinCode?.trim() || "";
                          let error = "";

                          if (trimmedPin.length !== 6) {
                            error = "Enter a valid 6-digit pin code";
                          } else if (trimmedPin === "000000") {
                            error = "Enter a valid 6-digit pin code";
                          }

                          setClientsFieldsError((prev) => ({
                            ...prev,
                            pinCodeError: error,
                          }));
                        }}
                        errorMessage={clientsFieldsError.pinCodeError}
                      />
                      <InputText
                        inputType={"text"}
                        title={"Number of Users Required"}
                        maxLength={5}
                        name={"noOfUsersRequired"}
                        classStar={"text-red-500"}
                        content={clientsFields.noOfUsersRequired}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            noOfUsersRequired: e.target.value,
                          })
                        }
                        errorMessage={clientsFieldsError.noOfUsersRequiredError}
                      />
                      <InputText
                        inputType={"text"}
                        title={"Subscription Period (Months)"}
                        maxLength={3}
                        name={"subscriptionPeriod"}
                        classStar={"text-red-500"}
                        content={clientsFields.subscriptionPeriod}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            subscriptionPeriod: e.target.value,
                          })
                        }
                        errorMessage={
                          clientsFieldsError.subscriptionPeriodError
                        }
                      />
                      <InputText
                        inputType={"text"}
                        title={"GST No. (Put NA if not applicable)"}
                        maxLength={100}
                        name={"gst"}
                        classStar={"text-red-500"}
                        content={clientsFields.gst}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            gst: e.target.value,
                          })
                        }
                        controlFuncBlur={() => {
                          setClientsFieldsError((clientsFieldsError) => ({
                            ...clientsFieldsError,
                            gstError:
                              clientsFields.gst &&
                              clientsFields.gst.trim().length > 0
                                ? /^[A-Za-z0-9,.'\-\/ ]+$/.test(
                                    clientsFields.gst,
                                  )
                                  ? ""
                                  : "Only alphabets, numbers, commas, dots, apostrophes, hyphens, slashes, and spaces allowed"
                                : "Enter GST",
                          }));
                        }}
                        errorMessage={clientsFieldsError.gstError}
                      />
                    </div>
                    <div class={mainTable.labelBold}>Contact Info</div>
                    <hr class={mainTable.horizontalLine}></hr>
                    <div class="grid gap-4 mb-6 md:grid-cols-3">
                      <InputText
                        inputType={"text"}
                        title={"First Name"}
                        name={"firstName"}
                        classStar={"text-red-500"}
                        maxLength={50}
                        content={clientsFields.firstName}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            firstName: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setClientsFieldsError((clientsFieldsError) => ({
                            ...clientsFieldsError,
                            firstNameError:
                              clientsFields.firstName &&
                              clientsFields.firstName.length > 0
                                ? /^[A-Za-z.'\-][A-Za-z.'\- ]{2,50}$/.test(
                                    clientsFields.firstName,
                                  )
                                  ? ""
                                  : clientsFields.firstName.length < 2
                                    ? "Minimum 2 characters required"
                                    : clientsFields.firstName.length > 50
                                      ? "Maximum 50 characters allowed"
                                      : "Only alphabets, dot, apostrophe, hyphen, and space allowed"
                                : "Enter First Name",
                          }));
                        }}
                        errorMessage={clientsFieldsError.firstNameError}
                      />
                      <InputText
                        inputType={"text"}
                        title={"Last Name"}
                        name={"lastName"}
                        classStar={"text-red-500"}
                        maxLength={50}
                        content={clientsFields.LastName}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            LastName: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          const trimmedLastName =
                            clientsFields.LastName?.trim() || "";

                          setClientsFieldsError((clientsFieldsError) => ({
                            ...clientsFieldsError,
                            LastNameError:
                              trimmedLastName.length > 0
                                ? /^[A-Za-z.'\- ]{1,50}$/.test(trimmedLastName)
                                  ? ""
                                  : trimmedLastName.length > 50
                                    ? "Maximum 50 characters allowed"
                                    : "Only alphabets, dot, apostrophe, hyphen, and space allowed"
                                : "Enter Last Name",
                          }));
                        }}
                        errorMessage={clientsFieldsError.LastNameError}
                      />

                      <AutoDropDown
                        title="Designation"
                        options={designationBindDD}
                        placeholder="Select"
                        name="designation"
                        selectedOption={
                          clientsFields.designation
                            ? designationBindDD.find(
                                (x) => x.value == clientsFields.designation,
                              )
                            : ""
                        }
                        Class="custom-class"
                        // // tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value, e) => {
                          handleClientsFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setClientsFieldsError(() => ({
                            ...clientsFieldsError,
                            contactPersonDesignationError:
                              clientsFields.designation
                                ? ""
                                : "Select Designation",
                          }));
                        }}
                        errorMessage={
                          clientsFieldsError.contactPersonDesignationError
                        }
                      />
                      <InputText
                        inputType={"text"}
                        title={"Contact Number"}
                        name={"contactNumber"}
                        classStar={"text-red-500"}
                        maxLength={15}
                        content={clientsFields.contactNumber}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            contactNumber: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setClientsFieldsError((clientsFieldsError) => ({
                            ...clientsFieldsError,
                            contactNumberError:
                              clientsFields.contactNumber &&
                              clientsFields.contactNumber.length > 0
                                ? /^\+?[0-9]{7,15}$/.test(
                                    clientsFields.contactNumber,
                                  )
                                  ? ""
                                  : "Only digits allowed, with optional + at start (7 to 15 digits)"
                                : "Enter Contact Number",
                          }));
                        }}
                        errorMessage={clientsFieldsError.contactNumberError}
                      />
                      <InputText
                        inputType={"text"}
                        title={"Email"}
                        classStar={"text-red-500"}
                        name={"email"}
                        maxLength={50}
                        content={clientsFields.email}
                        controlFunc={(e) =>
                          setClientsFields({
                            ...clientsFields,
                            email: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setClientsFieldsError((clientsFieldsError) => {
                            let emailError = "";

                            if (
                              !clientsFields.email ||
                              clientsFields.email.length === 0
                            ) {
                              emailError = "Enter Email";
                            } else if (
                              !/^[a-z0-9._%-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(
                                clientsFields.email,
                              )
                            ) {
                              emailError = "Enter Valid Email Id";
                            } else if (
                              !updateScreenTitle &&
                              bindContactNoAndEmailDatas.find(
                                (x) =>
                                  (x.Email?.toLowerCase() || "") ===
                                  (clientsFields.email?.toLowerCase() || ""),
                              )
                            ) {
                              emailError = "Email address already available";
                            }

                            return {
                              ...clientsFieldsError,
                              emailError,
                            };
                          });
                        }}
                        errorMessage={clientsFieldsError.emailError}
                      />
                    </div>

                    <FileUpload
                      title="Logo"
                      apiCall="ClientsAPI/LogoUpload"
                      modalName="Logo"
                      name="showImage"
                      disabledBtn={updateScreenTitle}
                      showImageData={handleShowImage}
                      imageUploadedError={clientsFieldsError.showImageError}
                      showImage={clientsFields.showImage}
                      imageShow={false}
                      clear={fileClear}
                      limitMassage={
                        "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                      }
                      MAX_FILE_SIZE_MB={2}
                      ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                    />
                    <div className={mainTable.grid2}>
                      <div>
                        <div className="mb-2">
                          <label className="block mb-2 text-sm capitalize font-medium text-neutral-700">
                            Property photo
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef}
                          className={mainTable.input}
                          onChange={handleFileChange}
                          disabled={fileDisabled ? true : false}
                          accept=".jpg, .jpeg, .png"
                        />
                        {clientsFieldsError.showMultiImageError && (
                          <span className="text-red-500 text-sm font-medium">
                            {clientsFieldsError.showMultiImageError}
                          </span>
                        )}
                        {selectedFiles.length > 3 && (
                          <div className="text-red-500 text-sm font-medium">
                            Reached Maximum No. of Uploads
                          </div>
                        )}
                      </div>
                    </div>

                    <div>
                      {selectedFiles.length > 0 && (
                        <div class="flex gap-8">
                          {selectedFiles.map((item, index) => (
                            <div key={index} className="image-container">
                              <span
                                class="float-right cursor-pointer"
                                onClick={() => handleImageCancel(index)}
                              >
                                X
                              </span>
                              <img
                                src={item.previewUrl}
                                alt={`preview-${index}`}
                                class={`w-28 h-28 m-3`}
                              />
                              <span class={mainTable.label}>
                                {item.file?.name}
                              </span>
                              {index === selectedFiles.length - 1 && (
                                <input
                                  type="button"
                                  className={
                                    imageDisabled
                                      ? mainTable.disabledSubmitButton
                                      : mainTable.submitButton
                                  }
                                  onClick={handleUpload}
                                  disabled={imageDisabled ? true : false}
                                  value="Upload"
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="border rounded-md shadow-sm">
                      <div class="my-1 py-2 max-lg:mt-4 mx-2 lg:mx-4 text-sm max-h-52 overflow-auto font-medium text-neutral-700">
                        By registering your hotel on stay-cool.com, you agree to
                        provide accurate and up-to-date information about your
                        property, including room details, availability, pricing,
                        amenities, photos, and policies. You confirm that you
                        are authorized to represent the hotel and that the
                        property complies with all applicable local laws, safety
                        regulations, and licensing requirements. You are solely
                        responsible for managing bookings, updating
                        availability, honoring confirmed reservations, and
                        handling cancellations, no-shows, and customer service
                        in accordance with the policies you define and share
                        with us. The platform may charge a commission for each
                        successful booking, as mutually agreed upon during the
                        onboarding process. Payouts will be made to the bank
                        account you provide, following the selected payout
                        schedule. You grant us the right to use your property’s
                        content—including images, descriptions, and branding—for
                        listing and marketing purposes. You acknowledge that
                        guest reviews and ratings will be visible on your
                        listing and agree not to manipulate or misrepresent
                        guest feedback in any way. The platform is not liable
                        for guest behavior, service disputes, or indirect
                        damages resulting from your hotel’s operations. We
                        reserve the right to suspend or remove your listing if
                        there is a breach of these terms, repeated customer
                        complaints, or non-compliance with applicable laws. You
                        may also request deactivation by notifying us in
                        writing. This agreement is governed by the laws of
                        [Jurisdiction], and any disputes will be handled in the
                        courts of [City, State]. Continued use of the platform
                        implies acceptance of the most current version of these
                        Terms and Conditions. For support, contact us at
                        support@stay-cool.com.
                      </div>
                      <div className="">
                        <div className=" text-xs p-2 lg:px-4 text-red-500 flex flex-col">
                          <Checkbox
                            Class="flex"
                            title="Terms and Conditions :"
                            options={[
                              {
                                value: 1,
                                label: "I accept the terms and conditions.",
                              },
                            ]}
                            controlFunc={handleCheckboxChange} // or a real function handler
                            disabled={false}
                            setName={"checkboxStatus"}
                            selectedOptions={
                              checkboxStatus ? checkboxStatus : []
                            }
                            // tabIndex="0"
                          />
                          {clientsFieldsError.checkboxStatusError && (
                            <div className="text-red-500">
                              {clientsFieldsError.checkboxStatusError}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-6">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              disabledBtn={submitBtnDisabled ? true : false}
              viewSaveButton={false}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
          </div>
        </>
      )}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)} // Outside click closes modal
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            <GridPage
              title="Invoices View"
              header={invoicesHeader}
              records={bindInvoicesData}
              blockView={true}
              addView={true}
            />
          </div>
        </div>
      )}
      <MainPopup popUpOpen={popUpOpen} setpopUpOpen={setpopUpOpen}>
        <div>
          <PopUpScreenTitle
            title={`Clients`}
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            uploadDetails={uploadDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            userDeactivateDetails={userDeactivateDetails}
            userActivateDetails={userActivateDetails}
          />

          <ClientPopup
            data={partnerData}
            data1={partnerdata2}
            isLoading={isLoading}
            flag={popupFlag}
            ref={childRef}
            popupImage={popupImage}
            popupUser={popupUser}
            setpopUpOpen={setpopUpOpen}
            onDataChange={handleClientData}
            selectedUsers={handleSelectedUser}
            selectedUsersClear={selectedUsersClear}
            selectedUsersClearflase={handleSelectedUserClear}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          uploadDetails={uploadDetails}
          userDeactivateDetails={userDeactivateDetails}
          userActivateDetails={userActivateDetails}
          handleSubmit={handleSubmit}
          handleUpload={handleClick}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Client;
